import { render, staticRenderFns } from "./IncomeMarketplace.vue?vue&type=template&id=1bd6a6a8"
import script from "./IncomeMarketplace.vue?vue&type=script&lang=js"
export * from "./IncomeMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports